import React ,{Component} from 'react';
import { NavLink,Navigate  } from 'react-router-dom';
import axios from 'axios';
import Button from '@mui/material/Button';
import { styled } from '@mui/system';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import TableHead from '@mui/material/TableHead';
import TableCell from '@mui/material/TableCell';
import TableSortLabel from '@mui/material/TableSortLabel';
import TablePagination from '@mui/material/TablePagination';
import TableBody from '@mui/material/TableBody'; 
import SettingsIcon from '@mui/icons-material/Settings';
import IosShareIcon from '@mui/icons-material/IosShare';
import Collapse from '@mui/material/Collapse';
import CloseIcon from '@mui/icons-material/Close';
import Alert from '@mui/material/Alert';
import IconButton from '@mui/material/IconButton';
import TextField from '@mui/material/TextField';
import dayjs from 'dayjs';
import SearchOutlinedIcon from '@mui/icons-material/SearchOutlined';
import { DemoContainer, DemoItem } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import ReactHTMLTableToExcel from 'react-html-table-to-excel';
import Select from '@mui/material/Select';
import FormControl from '@mui/material/FormControl';
import Checkbox from '@mui/material/Checkbox'; 
import FormControlLabel from '@mui/material/FormControlLabel'; 
import IosShareOutlinedIcon from '@mui/icons-material/IosShareOutlined';
import { blueGrey } from '@mui/material/colors';
import DragHandleIcon from '@mui/icons-material/DragHandle';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import Tooltip from '@mui/material/Tooltip';
import ReactToPrint from 'react-to-print';
import LocalPrintshopIcon from '@mui/icons-material/LocalPrintshop';
import EmailTwoToneIcon  from '@mui/icons-material/EmailTwoTone';
import ContentCopyTwoToneIcon from '@mui/icons-material/ContentCopyTwoTone';
import DeleteIcon from '@mui/icons-material/Delete';
import Sendemail from './Sendemail';
import Columnsettings from './Columnsettings';
const useStyles = styled({   
  root: {  
    width: '100%',  
  },  
  container: {  
    maxHeight: 440,  
  }, 
  table: {
    minWidth: 750,
  },
  visuallyHidden: {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: 1,
    margin: -1,
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    top: 20,
    width: 1,
  },  
});
export default class Adminsalesinvoice extends Component {
    constructor(props) {
    super(props);
	var strdob = new Date();
var month = "";
if ((strdob.getMonth() + 1) < 10) {
    month = "0" + (strdob.getMonth() + 1);
} else {
    month = (strdob.getMonth() + 1);
}
const currentDate = new Date();
var month1 = (currentDate.getMonth() + 1 < 10) ? "0" + (currentDate.getMonth() + 1) : (currentDate.getMonth() + 1);
var lastDayOfMonth = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0);
var lastDay = (lastDayOfMonth.getDate() < 10) ? "0" + lastDayOfMonth.getDate() : lastDayOfMonth.getDate();
 this.state = { 
 sestatus:'',isselectdisplay:false,  checkedvalues: '' ,checkboxData:'',quotenumber:'',open:false,
	 todate1: currentDate.getFullYear() + '-' + month1 + '-' + lastDay, todate: lastDayOfMonth,
fromdate: new Date(currentDate.getFullYear(), currentDate.getMonth(), 1),
 fromdate1:currentDate.getFullYear() + '-' + month1 + '-' + '01',company:'',se_quotenumber:'',
redirect:false,pagename:'',CustomerData:[] ,id:'',page:0 ,prevpage:0,totaldata:0,rowsPerPage:50,rowsPaging:[],
search:'',order:'desc' ,orderBy:'sin_id',
	 salesInvoicedata:[],ColumnData:[],sinidies:'',iconslist:false,allchecked:false,colcount:0,
		totalrecords:0,selectedcount:0,exportaData:[],
	}
	this.updateColumnssetting=this.updateColumnssetting;       
	}
updateColumnssetting = (text) => {
this.ColumheaderinvoiceApi();
	}
 myChangeHandler = (event) => {
  let nam = event.target.name;
  let val = event.target.value;
  this.setState({[nam]: val});
 } 
componentWillMount() {
	document.title = "Isifol - Sales Invoice";
if(localStorage.getItem("ISIuserid")==null)
		  {
		   this.setState({
            redirect: true,
			pagename:'/Login'
          })
		  }
else
{	
if(localStorage.getItem("ISIrole")==="1" || localStorage.getItem("ISIrole")==="2")
		  {
			  this.apicall(this.state.page,this.state.rowsPerPage);  
		  }
		  else{
		this.PageAccessCheckApi();
		  }
	}	  
		   this.props.parentdasCallback(
            "Sales Invoice~"
        );
}
PageAccessCheckApi() {
  axios.get(localStorage.getItem("ISIurl")+'ajaxpagemaster.php?action=getbyuser&us_id='+localStorage.getItem('ISIuserid')+'&up_pm_id=2')
  .then(resp => {
	  let strreturn=resp.data;
      if (strreturn!==0) {
         this.apicall(this.state.page,this.state.rowsPerPage);  
      } else {
        this.setState({redirect: true,pagename: "/Accesspagemessage"});
      }
  });
}
apicall(page,rowsPerPage){
	axios.get(localStorage.getItem("ISIurl")+'ajaxsalesinvoice.php?action=getall&sin_cmp_id='+localStorage.getItem("ISIcmpid")+'&sin_status='+this.state.sestatus+'&sin_quotenumber='+this.state.quotenumber+'&StartIndex='+page+'&PageSize='+rowsPerPage)
	//axios.get(localStorage.getItem("ISIurl")+'ajaxsalesinvoice.php?action=getall&sin_status='+this.state.sestatus+'&fromdate='+this.state.fromdate1+'&todate='+this.state.todate1+'&sin_quotenumber='+this.state.quotenumber+'&StartIndex='+page+'&PageSize='+rowsPerPage)
  .then(resp => { 
  
    if(resp.data.length>0){
		let copy=[50, 100, 150, 200, 250];
			this.setState({  
			  salesInvoicedata: resp.data,  
			   totaldata:parseInt(resp.data[0].count),
			   rowsPaging:[],rowsPaging:copy,
			   totalrecords:parseInt(resp.data[0].count),
			},()=>{
			});
     }
	  else{
		   this.setState({salesInvoicedata:[],totaldata:0});
	 }
  this.ColumheaderinvoiceApi();
    });
}
GetexportaData(id){
	axios.get(localStorage.getItem("ISIurl")+'ajaxsalesinvoice.php?action=getall&sin_id='+id)
  .then(resp => {  	
    if(resp.data.length>0){
			this.setState({  
			  exportaData: resp.data,
			});
     }
	  else{
		   this.setState({exportaData:[]});
	 }
    });
}
ColumheaderinvoiceApi(){
	axios.get(localStorage.getItem("ISIurl")+'ajaxcolumnconfigure.php?action=getall&cc_userid='+localStorage.getItem("ISIuserid")+'&cc_page=2&cc_isdisplay=1')
  .then(resp => {  	
    if(resp.data.length>0){
			this.setState({  
			  ColumnData: resp.data,  
			   colcount:parseInt(resp.data[0].count),
			});
     }
	  else{
		   axios.get(localStorage.getItem("ISIurl")+'ajaxcolumnconfigure.php?action=getall&cc_userid=0&cc_page=2&cc_isdisplay=1')
  .then(resp => {  	
				if(resp.data.length>0){
						this.setState({  
						  ColumnData: resp.data,  
						   colcount:parseInt(resp.data[0].count),
						});
				 }
	     });
	 }
    });
}
handleClickSearch=()=>{
 this.apicall(this.state.page,this.state.rowsPerPage); 
}
handleChangePage = (event, newPage) => {  
    this.setState({  
      page: newPage,
      rowsPerPage:this.state.rowsPerPage
    },()=>{ this.apicall(this.state.page,this.state.rowsPerPage);  });
  }; 
   handleChangeRowsPerPage = event => {  
    let pageval = event.target.value;
    this.setState({  
      page: 0,
      rowsPerPage:parseInt(pageval),
	  prevpage:-1
    },()=>{ this.apicall(this.state.page,this.state.rowsPerPage); }); 
  };
fromdatehandler = (date) => {
    var month = "";
    var dateObj = new Date(date);
       if ((dateObj.getMonth() + 1) < 10) {
        month = "0" + (dateObj.getMonth() + 1);
    } else {
        month = (dateObj.getMonth() + 1);
    }
    this.setState({
        fromdate: dayjs(dateObj),
        fromdate1: dateObj.getFullYear() + '-' + month + '-' + dateObj.getDate()
    });
}
  toatehandler = (date) => {
    var month = "";
    var dateObj = new Date(date);
       if ((dateObj.getMonth() + 1) < 10) {
        month = "0" + (dateObj.getMonth() + 1);
    } else {
        month = (dateObj.getMonth() + 1);
    }
  }
  CloseMoreoption = (date) =>{
	this.setState({isselectdisplay:false});
}
   Handleclickviewmore= (e) =>{
	  this.setState({isselectdisplay:true});
  }
	handleOpen = () => {
    this.setState({ open: true });
  };
handleClickOpen = (e) => { 
  this.setState({open:!this.state.open,
	  });
};
      addcheckbox(){
    setTimeout(() => this.refs.Columnsettings.handleClickOpen(),500);
	  }
   HandleAllcheckbox=()=>{
           this.setState({iconslist:true});
         var studArray = this.state.salesInvoicedata;
         const updatedArray = [...this.state.salesInvoicedata];
         console.log('bulkdata',updatedArray);
         this.setState({allchecked:!this.state.allchecked},() => {
             if(this.state.allchecked===false)
                 {
                 var subnewRow=studArray.map((rowssub,j) => {
                                         updatedArray[j].isseleceted = "0" ;
                                 });
                            this.setState({iconslist:false});               
                  }
                 else if(this.state.allchecked===true)
                         {
                                  var subnewRow = studArray.map((rowssub, j) => {
                                   updatedArray[j].isseleceted = "1" ;
                           });
                         }
                        this.setState({salesInvoicedata:updatedArray,},()=>{
                        const selectedItems= this.state.salesInvoicedata.filter(item => item.isseleceted==="1")
                 this.setState({selectedcount:selectedItems.length}); 
                  const selectedIds = selectedItems.map(item => item.sin_id);
                  const selectedIdsString = selectedIds.join(',');
                  this.setState({sinidies:selectedIdsString},()=>{
                           this.GetexportaData(this.state.sinidies)
                  },()=>{
                    if(this.state.sinidies!=="")
                          {
                         this.setState({iconslist:true});
                          }
                  });   
                  if (selectedIds.length >= 2) {
         this.setState({disablecopyicon: false,});
         } 
                 else{
                         this.setState({disablecopyicon:true });
                 }
                        });
         }); 
  } 
  HandleCheckbox=(id,rowsd)=>{
  const updatedArray=[...this.state.salesInvoicedata];
          if(updatedArray[rowsd].isseleceted==="0")
          {
                  updatedArray[rowsd].isseleceted = "1" ;
                    console.log('check',updatedArray);
          }
          else
          {
          updatedArray[rowsd].isseleceted = "0" ;
           console.log('unchcek',updatedArray);
      }
          this.setState({salesInvoicedata: updatedArray,},()=>{
                 const selectedItems= this.state.salesInvoicedata.filter(item => item.isseleceted==="1")
				   this.setState({selectedcount:selectedItems.length}); 
                  const selectedIds = selectedItems.map(item => item.sin_id);
                  const selectedIdsString = selectedIds.join(',');
                  this.setState({sinidies:selectedIdsString},()=>{
                          if(this.state.sinidies!=="")
                          {
                         this.setState({iconslist:true});
						   this.GetexportaData(this.state.sinidies)
                          }
                          else if(this.state.sinidies === "")
                          {
                                   this.setState({iconslist:false});
                          }
                  });
                 if (selectedItems.length >= 2) {
         this.setState({disablecopyicon: false });
         } 
                 else{
                         this.setState({disablecopyicon: true });
                 }
          }) ;
  }
  onClickBulkdelete(){
	const idsArray = this.state.sinidies.split(",").filter(id=>id.trim() !==""); 
    const count = idsArray.length; 
    if (count === 0) {
   this.setState({errormessage:"You Have Not Checked any checkbox Please select any one",erropen:true,});
		 window.scrollTo({top: 0})
		 return false;
    return; 
  }
	  let r = window.confirm("Do you really want to Delete?");
		 if(r == true){
			  var formData = new FormData(); 
					 formData.append('action','delete')	
					 formData.append('sin_id',this.state.sinidies)
			         formData.append('userid',localStorage.getItem("ISIuserid"))
					  axios.post(localStorage.getItem("ISIurl")+"ajaxsalesinvoice.php", formData, {
						}).then(res =>{
							  this.apicall(this.state.page,this.state.rowsPerPage); 
						});
		 }
  }
    addprintbox(){
    setTimeout(() => this.refs.PrintBox.handleClickOpen(),500);
 }
 
 
 
 formatMoney = (value) => {
  const amount = parseFloat(value);
  return isNaN(amount) ? "0.00" : amount.toFixed(2);
};
 
 
	render()
	{
		 if (this.state.redirect === true) {
      return <Navigate to={this.state.pagename} />
    }
		const { checkedvalues } = this.state;
		return(
		   <React.Fragment>
<div className="searchbox">
<ul>
 <li>
 <div className="iconlistprinttop">
<span className="countreconds">{this.state.selectedcount + " of " + this.state.totalrecords + " selected"}</span>
{this.state.iconslist===true && (
 <React.Fragment>
<Tooltip title="Print" placement="top">
  <IconButton>
  <LocalPrintshopIcon onClick={()=>{this.refs.PrintBox.handleClickPrint();}}/>
  </IconButton>
</Tooltip>
<Tooltip title="Email" placement="top">
  <IconButton>
  <EmailTwoToneIcon  onClick={()=>{  this.refs.Sendemail.handleaddfileClose()}}/>
  </IconButton>
</Tooltip>
{this.state.disablecopyicon === true && (
 <a href={'/#/AddSalesinvoice?id='+this.state.sinidies+'&copy=1'} >
    <Tooltip title="Copy" placement="top">
      <IconButton>
        <ContentCopyTwoToneIcon />
      </IconButton>
    </Tooltip>
  </a>
)}
<Tooltip title="Delete" placement="top">
  <IconButton>
 <DeleteIcon onClick={()=>{this.onClickBulkdelete()}} />
  </IconButton>
</Tooltip>
 <Tooltip title="Export" placement="top">
  <ReactHTMLTableToExcel
    id="exportbtndisble"
    table="Saleinvoice"
    filename="Sales Invoice Report"
    sheet="Sale Invoice Report"
    buttonText= <IosShareIcon />
    style={{display:"none" }} 
  /> 
   <IconButton onClick={() => { this.GetexportaData(); }}>
  </IconButton>
</Tooltip>
 </React.Fragment>
)}
</div>
</li>
 <li>
        <p>Search</p>
        <p>
          <TextField
            variant="outlined"
            fullWidth
			className="txtbox"
            value={this.state.quotenumber}
            id="quotenumber"
            inputProps={{ tabIndex: "1", maxLength: 150 }}
            name="quotenumber"
            onChange={this.myChangeHandler}
            InputProps={{
              endAdornment: (
                <SearchOutlinedIcon style={{ marginLeft: 8 }} />
              ),
            }}
          />
        </p>
      </li>
<li>
<p><p>From Date</p>
<LocalizationProvider dateAdapter={AdapterDayjs}>
<DemoContainer components={['DatePicker']}>
<DatePicker
value= {dayjs(this.state.fromdate) }
className="txtbox"
    onChange={this.fromdatehandler} format="MM/DD/YYYY"
/>  </DemoContainer>
</LocalizationProvider></p>
</li>
<li>
<p><p>To Date</p>
<LocalizationProvider dateAdapter={AdapterDayjs}>
<DemoContainer components={['DatePicker']}>
<DatePicker
value= {dayjs(this.state.todate) }
className="txtbox"
onChange={this.toatehandler} format="MM/DD/YYYY"
/>  </DemoContainer>
    </LocalizationProvider> </p></li>
<li>
<p>&nbsp;</p>
<p>
<Button
type="submit"
variant="outlined" 
className="morebtn"
onClick={this.Handleclickviewmore}
          >
            More
          </Button>
  <span className="closeincon">
   {this.state.isselectdisplay === true && (
      <CloseRoundedIcon onClick={this.CloseMoreoption} />
    )}
   </span>
</p>
</li>
<li>
<p>&nbsp;</p>
	 <p className="searchbutton">
       <Button
  type="submit"
  variant="contained"
  className="frmSecondarybtn"
  onClick={this.handleClickSearch}
>
  Search 
</Button>
      </p>
</li>
</ul>
<PrintBox ref="PrintBox" childcols={this.state.ColumnData} sinidies={this.state.sinidies}/>
<Columnsettings 
ref="Columnsettings"  
pageval={2}
updateDonenew={this.updateColumnssetting}/>	
<ul>
	{this.state.isselectdisplay===true &&(
	<li>
<p>Status</p> <p><Select
  native
  variant="outlined" className="txtbox"
  margin="normal"
  fullWidth 
  onChange={this.myChangeHandler}
  id="role"
  value={this.state.sestatus}
  name="sestatus"
  inputProps={{tabIndex: "4"}}
        >
		  <option value={0}>All</option>
  <option value={1}>Draft</option>
  <option value={2}>Unpaid</option>
  <option value={3}>Part Paid</option>
  <option value={4}>Paid</option>
  <option value={5}>Void</option>
  <option value={6}>Outstanding</option>
  <option value={7}>Overdue</option>
  <option value={8}>Pro Forma</option>
  </Select></p>
</li>
	)}
</ul>
</div>	
<div className="addandbacbtn"> <NavLink  to="/AddSalesinvoice" className="frmSecondarybtn">New Invoice</NavLink></div>		
	<div className="clear"></div>
<div className="estimatebox">
<div onClick={this.handleOpen} className="ui-conatiner">
       <span className="congiguration" onClick={()=>{this.addcheckbox()}}>   <SettingsIcon /> </span>
        </div>
<Paper className={useStyles.root}>
<TableContainer className={useStyles.container}>  
<Table stickyHeader aria-label="sticky table"> 
 <TableHead>
          <TableRow>
            <TableCell>   
			<Checkbox 
           checked={this.state.allchecked}
           onChange={()=>{this.HandleAllcheckbox()}}
            inputProps={{ 'aria-label': 'controlled' }}
            sx={{
          color: 'white', 
         '&.Mui-checked': {
            color: 'white', 
        },
    }}
              /> 	
			</TableCell>
		   {this.state.ColumnData.map((cols,i) => {  
           return (
		    <TableCell>{cols.cc_displayname}</TableCell>
		   )
		  })}
          </TableRow>
        </TableHead>
  <TableBody>
{this.state.salesInvoicedata.map((item,index) => {  
           return ( <React.Fragment>
  <TableRow key={index} >
<TableCell>{item.isseleceted==="0" && (
        <Checkbox
         onChange={()=>{this.HandleCheckbox(item.sin_id,index)}}
         inputProps={{ 'aria-label': 'controlled' }}
		      sx={{'&.Mui-checked': {
            color: 'gray', 
                },
                }}
        /> 
      )}{item.isseleceted==="1" && (
        <Checkbox
      checked
      onChange={()=>{this.HandleCheckbox(item.sin_id,index)}}
	       sx={{ '&.Mui-checked': {
            color: 'gray', 
            },
          }}
     /> 
     )}</TableCell>
{this.state.ColumnData.map((cols,i) => { 
	  let colsname	=  cols.cc_columnname; 
	  return ( <React.Fragment>
 {colsname!=="sin_file" &&(<React.Fragment>
 <TableCell>
  {(colsname!=="total" ) &&(
 <a className="link" href={"#/Salesinvoiceviewmore?sinoid="+item.sin_id+""}>   {(colsname === "iop_total" || colsname === "dueamount")
      ? (parseFloat(item[colsname]) || 0).toFixed(2)
      : item[colsname]}</a>
  )}
  {(colsname==="total" ) &&(
 <a className="link" href={"#/Salesinvoiceviewmore?sinoid="+item.sin_id+""}>
 {
	(parseFloat(item.iop_total)).toFixed(2)}</a>
	 )}
  </TableCell>
 </React.Fragment>)}
  {(colsname==="sin_file" ) &&(
	 <TableCell>
	 {( item.sin_file!=="") &&(
 <a className="link" href={localStorage.getItem("ISIurl")+"uploads/"+item.sin_file+""} target="_blank">View</a>
  )}
 </TableCell>
	 )}
			</React.Fragment>	);
					})}
					 </TableRow>
				</React.Fragment>	
				);
					})}
					{this.state.salesInvoicedata.length===0 &&(
					<TableRow key={0} >
<TableCell align="center" colspan={this.state.colcount}>No Records</TableCell>
					</TableRow>
					) }
 </TableBody>
</Table>
  </TableContainer> 
  <TablePagination  
           rowsPerPageOptions={[50, 100, 150,200]} 
        component="div"  
        count={this.state.totaldata}  
        rowsPerPage={this.state.rowsPerPage}  
        page={this.state.page}  
        onPageChange={this.handleChangePage}  
        onRowsPerPageChange={this.handleChangeRowsPerPage}  
      />    
  </Paper>
 </div>
<div style={{"display":"none"}}>
<Paper className={useStyles.root}>
  <TableContainer className={useStyles.container}>  
  <Table stickyHeader aria-label="sticky table" id="Saleinvoice">  
<TableHead> 
<TableRow>
            {this.state.ColumnData.map((cols,i) => {  
           return (
		    <TableCell>{cols.cc_displayname}</TableCell>
		   )
		  })}
                      </TableRow></TableHead>
                      <TableBody>
                     {this.state.exportaData.map((item,index) => {  
           return (
 <React.Fragment>
 <TableRow key={index} >
{this.state.ColumnData.map((cols,i) => { 
	  let colsname	=  cols.cc_columnname; 
	  return ( <React.Fragment>
 {colsname!=="sin_file" &&(<React.Fragment>
 <TableCell>
  {(colsname!=="total" ) &&(
 <span>{item[""+colsname+""]}</span>
  )}
  {(colsname==="total" ) &&(
 <a className="link" href={"#/Salesinvoiceviewmore?sinoid="+item.sin_id+""}>
 {
	(parseFloat(item.iop_total)+parseFloat(item.sin_shippingcharges)).toFixed(2)}</a>
	 )}
  </TableCell>
 </React.Fragment>)}
  {(colsname==="sin_file" ) &&(
	 <TableCell>
	 {( item.sin_file!=="") &&(
 <a className="link" href={localStorage.getItem("ISIurl")+"uploads/"+item.sin_file+""} target="_blank">View</a>
  )}
 </TableCell>
	 )}
			</React.Fragment>	);
					})}
 </TableRow>
 </React.Fragment>	
);
					})}
{this.state.totaldata===0 &&(
					<TableRow key={0} >
<TableCell align="center" colspan={this.state.colcount}>No Records</TableCell>
</TableRow>
					) }
 </TableBody>
</Table>
  </TableContainer> 
  </Paper>
</div>
  <Sendemail ref="Sendemail" 
emailid={''}
 id={this.state.sinidies} 
 headingname="Sales Invoice"
 adminname="Sales invoice"
 aoid="8"
 />
	   </React.Fragment>	
		)
	}
}
export class PrintBox extends Component {
  constructor(props) {
    super(props);
    this.state = {
      printopen: false,
	  invoiceArray:[],
    };
  }
 handleClickPrint = () => {
  this.GetSalesinvoiceIds(this.props.sinidies)
};
 GetSalesinvoiceIds(id){
axios.get(localStorage.getItem("ISIurl")+'ajaxsalesinvoice.php?action=getall&sin_id='+id)
  .then(resp => {  	
    if(resp.data.length>0){
			this.setState({  
			  invoiceArray: resp.data,  
			},()=>{
				 setTimeout(() =>
document.getElementById('print-button').click() 
,500);
			});
     }
	  else{
		   this.setState({invoiceArray:[]});
	 }
    });
}
  render() {
 return (
	 <React.Fragment>
	 <div className="printmod">
	<div
    ref={el => (this.componentRef = el)}
>
<Paper className={useStyles.root}>
<TableContainer className={useStyles.container}>  
<Table stickyHeader aria-label="sticky table"> 
 <TableHead>
          <TableRow>
		  {this.props.childcols.map((cols,i) => {  
           return (
		    <TableCell>{cols.cc_displayname}</TableCell>
		   )
		  })}
          </TableRow>
        </TableHead>
  <TableBody>
{this.state.invoiceArray.map((item,index) => {  
           return ( <React.Fragment>
 <TableRow key={index} >
{this.props.childcols.map((cols,i) => { 
	  let colsname	=  cols.cc_columnname; 
	  return ( <React.Fragment>
 {colsname!=="sin_file" &&(<React.Fragment>
 <TableCell>
  {(colsname!=="total" ) &&(
 <span>{item[""+colsname+""]}</span>
  )}
  {(colsname==="total" ) &&(
 <span>
 {
	(parseFloat(item.iop_total)+parseFloat(item.sin_shippingcharges)).toFixed(2)}</span>
	 )}
  </TableCell>
 </React.Fragment>)}
  {(colsname==="sin_file" ) &&(
	 <TableCell>
	 {( item.sin_file!=="") &&(
 <a className="link" href={localStorage.getItem("ISIurl")+"uploads/"+item.sin_file+""} target="_blank">View</a>
  )}
 </TableCell>
	 )}
			</React.Fragment>	);
					})}
 </TableRow>
				</React.Fragment>	
				);
					})}
 </TableBody>
</Table>
  </TableContainer> 
  </Paper>
</div>
<ReactToPrint 
            trigger={() => <p id="print-button" className="Primarybuttons">Print </p>}
			content={() =>  this.componentRef} />
		</div>	
			 </React.Fragment>
 ) }
}